import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Vue from 'vue';
import './plugins/bootstrap-vue';
import './plugins/axios';
import App from './App.vue';
import store from './store/store';
import router from './router';
import './fontawesome';
import components from './components';
import { i18n } from './plugins/i18n';
import { keycloakAuth } from './services/keycloak';
import { ApmVuePlugin } from '@elastic/apm-rum-vue';
import apmRumDefaultConfig from '@/config/apm-rum-default-config';
import VueRouterDuplicateFix from './plugins/vue-router-duplicate-fix';

import VueTheMask from 'vue-the-mask';

import Clipboard from 'v-clipboard';

Vue.config.productionTip = false;

Vue.use(VueTheMask);

Vue.use(Clipboard);

Vue.use(VueRouterDuplicateFix, {
    router,
});

for (const index in components) {
    Vue.component(components[index].name, components[index]);
}

Vue.use(ApmVuePlugin, {
    router,
    config: {
        active: process.env.VUE_APP_APM_ACTIVE || apmRumDefaultConfig.DEFAULT_VUE_APP_APM_ACTIVE,
        serviceName: process.env.VUE_APP_APM_SERVICE_NAME || apmRumDefaultConfig.DEFAULT_VUE_APM_SERVICE_NAME,
        serviceVersion: process.env.VUE_APP_VERSION || apmRumDefaultConfig.DEFAULT_VUE_APP_VERSION,
        serverUrl: process.env.VUE_APP_APM_SERVER_URL || apmRumDefaultConfig.DEFAULT_VUE_APP_APM_SERVER_URL,
        serverUrlPrefix: process.env.VUE_APP_APM_SERVER_PREFIX || apmRumDefaultConfig.DEFAULT_VUE_APP_APM_SERVER_PREFIX,
        environment: process.env.VUE_APP_APM_ENVIRONMENT || apmRumDefaultConfig.DEFAULT_VUE_APP_APM_ENVIRONMENT,
    },
});

keycloakAuth.then(() => {
    new Vue({
        i18n,
        router,
        store,
        render: h => h(App),
    }).$mount('#app');
}).catch(error => {
    alert(error);
    console.error(error);
});